<template>
    <section class="detail-bg">
      <div v-if="promotion" class="detail-content">
        <div class="detail-date">{{ formatISODateToCustom(promotion.updated_at) }}</div>
        <h2 class="detail-title">{{ promotion.title }}</h2>
        <img
          :src="getFullImageURL(promotion.offer_image)"
          :alt="promotion.title"
          class="detail-image"
          @error="onImageError"
        />
        <div class="detail-description" v-html="promotion.description"></div>
        <div>
        <button class="detail-back-button" @click="goToAllPromotions">返回優惠活動</button>
        </div>
      </div>
      <div v-else class="no-detail">
        <p>沒有選擇的優惠活動。</p>
      </div>
    </section>
  </template>
  
  <script>
  import { onImageError, getFullImageURL, formatISODateToCustom } from "@/util/util";
  import { globalParams } from "@/global";
  
  export default {
    name: "PromotionDetail",
    data() {
      return {
        promotion: null,
      };
    },
    methods: {
      formatISODateToCustom,
      onImageError,
      getFullImageURL,
      goToAllPromotions() {
        this.$router.push("/all-promotions");
      },
    },
    mounted() {
      this.promotion = globalParams.shownPromotion;
  
      if (!this.promotion) {
        this.$router.push("/all-promotions");
      }
    },
  };
  </script>
  
  <style scoped>
  .promotion-detail {
    display: flex;
    justify-content: center;
    /* align-items: center; */
    padding: 20px;
    margin: 0 auto;
    text-align: center;
    width: 100%;
    min-height: 100vh;
  }
  
  .promotion-content {
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: left; 
    text-align: left;
    background-color: #ffffff;
    border-radius: 15px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    max-width: 600px;
    width: 90%;
  }
  
  .promotion-date {
    color: #006400;
    font-weight: bold;
    font-size: 1rem;
    margin-bottom: 5px;
    margin-top:100px;
  }
  
  .promo-title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333333;
    margin-bottom: 10px;
    margin-top: 0px;
    margin-left:0px;
    text-align: left;
  }
  
  .promotion-image {
    width: 100%;
    height: auto;
    max-height: 400px;
    object-fit: cover;
    border-radius: 10px;
    margin-bottom: 15px;
  }
  
  .promotion-description {
    font-size: 1rem;
    color: #555555;
    text-align: left;
    margin-bottom: 20px;
    line-height: 1.6;
  }
  
  .back-button {
    background-color: #008000;
    color: #ffffff;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s;
    width:100px;
  }
  
  .back-button:hover {
    background-color: #005700;
  }
  
  .no-promotion {
    padding: 20px;
    background-color: #f8d7da;
    border-radius: 10px;
    color: #721c24;
  }
  </style>
  